import { parisToday } from "@erp/shared";
export const PERIOD_PRESETS = ["month", "lastMonth", "quarter", "year", "lastYear", "custom"] as const;
export type PeriodPreset = (typeof PERIOD_PRESETS)[number];

const iso = (y: number, m: number, d: number) => {
  const date = new Date(Date.UTC(y, m, d));
  return date.toISOString().slice(0, 10);
};

/** Today in France, whatever the device's time zone. */
export function todayIso(now = new Date()): string {
  return parisToday(now);
}

/** Inclusive date range for a preset; "custom" falls back to the current month. */
export function presetRange(preset: PeriodPreset, now = new Date()): { from: string; to: string } {
  // Month and year in France, whatever the device's time zone.
  const [y, month] = parisToday(now).split("-").map(Number) as [number, number];
  const m = month - 1;
  switch (preset) {
    case "lastMonth":
      return { from: iso(y, m - 1, 1), to: iso(y, m, 0) };
    case "quarter": {
      const start = m - (m % 3);
      return { from: iso(y, start, 1), to: iso(y, start + 3, 0) };
    }
    case "year":
      return { from: iso(y, 0, 1), to: iso(y, 11, 31) };
    case "lastYear":
      return { from: iso(y - 1, 0, 1), to: iso(y - 1, 11, 31) };
    default:
      return { from: iso(y, m, 1), to: iso(y, m + 1, 0) };
  }
}
